export default __webpack_public_path__ + "static/media/baku.868a2fa0.svg";